export { default } from './PartiuGpRegulamento';
